<template>
  <v-container>
    <v-row class="mb-0">
      <!-- Current Debt Summary -->
      <v-col
        cols="12"
        class="backgroundWhite text-h2"
        :class="$vuetify.display.xs ? 'currentDebtSummaryMob' : 'currentDebtSummary'"
      >
        {{ $t('L_current_debt_summary') }}
      </v-col>
      <v-col cols="12" class="rightSideGrey">
        <!-- ON MOBILE SCREEN - View More Details - expand more/less -->
        <v-row v-if="$vuetify.display.xs">
          <v-col class="text-center text-h5" v-if="selectedexpand !== index">
            {{ $t('L_view_more_details') }}
            <v-icon @click="selectedexpand = index" color="#333333" :icon="mdiChevronDown" />
          </v-col>
          <v-col class="text-center text-h5" v-else>
            {{ $t('L_hide_details') }}
            <v-icon @click="selectedexpand = -1" color="#333333" :icon="mdiChevronUp" />
          </v-col>
        </v-row>

        <!-- If debt data exists -->
        <v-row
          v-if="unpaidDebts.length !== 0 && (!$vuetify.display.xs || selectedexpand !== -1)"
          class="grayBorderBottom text-center px-2"
        >
          <v-row class="pt-0 pb-4">
            <v-col cols="12">
              <p
                :class="$vuetify.display.xs ? 'labelForRoundedBubbleMob' : 'labelForRoundedBubble'"
              >
                {{ $t('L_your_total_current_debt') }}
              </p>
              <p class="mt-4" :class="$vuetify.display.xs ? 'roundedBubbleMob' : 'roundedBubble'">
                {{ getBalance }}
              </p>
              <p
                class="mt-4"
                :class="$vuetify.display.xs ? 'labelForRoundedBubbleMob' : 'labelForRoundedBubble'"
              >
                {{ $t('L_you_will_be_in_debt_for') }}
              </p>
              <p class="mt-4" :class="$vuetify.display.xs ? 'roundedBubbleMob' : 'roundedBubble'">
                {{ getWillBeInDebtFor }}
              </p>
              <p
                class="mt-4"
                :class="$vuetify.display.xs ? 'labelForRoundedBubbleMob' : 'labelForRoundedBubble'"
              >
                {{ $t('L_your_total_interest_paid') }}
              </p>
              <p class="mt-4" :class="$vuetify.display.xs ? 'roundedBubbleMob' : 'roundedBubble'">
                {{ getTotalInterestPaid }}
              </p>
              <p
                class="mt-4"
                :class="$vuetify.display.xs ? 'labelForRoundedBubbleMob' : 'labelForRoundedBubble'"
              >
                {{ $t('L_your_toal_monthly_payment') }}
              </p>
              <p class="mt-4" :class="$vuetify.display.xs ? 'roundedBubbleMob' : 'roundedBubble'">
                {{ getMonthlyPayment }}
              </p>
            </v-col>
          </v-row>
        </v-row>

        <!-- Enter your information... -->
        <v-row
          v-if="unpaidDebts.length <= 1 && (!$vuetify.display.xs || selectedexpand !== -1)"
          class="rightSideGrey pt-4 text-center"
        >
          <v-col cols="12" md="12">
            <p>{{ $t('L_enter_your_information_to_see_how') }}</p>
          </v-col>
        </v-row>

        <!-- View My Plan Btn -->
        <v-row v-if="!$vuetify.display.xs || selectedexpand !== -1">
          <v-col cols="12">
            <!-- You need a minimum of 2 debts... -->
            <p
              v-if="!twoOrMoreDebtsAndMinOneUnpaidDebt"
              :class="$vuetify.display.xs ? 'font-size--16' : 'font-size--18'"
            >
              {{ $t('L_you_need_a_minimum') }}
            </p>
            <!-- View My Plan -->
            <OnexButton
              v-else
              name="viewMyPlanButton"
              @click="ViewMyPlan()"
              role="link"
              block
              :class="unpaidDebts.length === 1 ? 'disabledViewMyPlanBtn' : 'enabledViewMyPlanBtn'"
              :disabled="unpaidDebts.length === 0"
              class="widthViewMyPlanBtn"
            >
              {{ $t('L_view_my_plan') }}
            </OnexButton>
          </v-col>
        </v-row>
        <!-- Time to Pay Off -->
        <v-row v-if="unpaidDebts.length > 1" class="text-center">
          <!-- Get out of debt years and months sooner -->
          <v-col cols="12">
            <span
              :class="$vuetify.display.xs ? 'get_out_of_debtMob' : 'get_out_of_debt'"
              v-html="$t('L_get_out_of_debt_partial')"
            ></span>
            <p class="pt-0" :class="$vuetify.display.xs ? 'biggerBlueMob' : 'biggerBlue'">
              {{ getTimeForFasterPaymentDate }}{{ $t('L_sooner') }}
            </p>
            <p
              v-if="!$vuetify.display.xs || selectedexpand !== -1"
              class="pt-0"
              :class="$vuetify.display.xs ? 'font-size--18' : 'font-size--18'"
            >
              {{ $t('L_making_the_same') }}
            </p>
          </v-col>
        </v-row>

        <!-- View Important Assumption -->
        <v-row class="text-center font-weight-bold cursorPointer" @click="openImportantDisc">
          <v-col
            cols="12"
            :class="
              $vuetify.display.xs ? 'view_important_assumptionsMob' : 'view_important_assumptions'
            "
          >
            <p>{{ $t('L_view_important_assumptions') }}</p>
          </v-col>
        </v-row>

        <!-- If you have questions Always Show-->
        <v-row class="font-weight-bold text-center">
          <v-col cols="12">
            <p
              v-if="!$vuetify.display.xs || selectedexpand !== -1"
              class="font-size--18 font-weight-bold"
            >
              {{ $t('L_if_you_have_questions_about_debt') }}
            </p>
            <!-- Contact your rep button Always Show-->
            <OnexButton
              variant="outlined"
              primary
              class="borderColorMarine mt-3 mb-16 contactYourRepButtonText"
              @click="callContactYourRep"
            >
              {{ $t('L_contact_your_representative') }}
            </OnexButton>
          </v-col>

          <v-col class="text-center mb-4" cols="12"> </v-col>
        </v-row>
      </v-col>
      <ContactRep
        v-if="hasReps"
        v-model="contactYourRep"
        :agents="agents"
        @close="contactYourRep = false"
        @send-message="sendRepEmail($event)"
        close-selector="contact_your_rep_close"
        modal-class="contact_your_rep_modal"
        :sender="sender"
      />
    </v-row>
  </v-container>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import { openInNewWindow } from '@/mixins/openNewWindow';
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import { mapActions, mapState } from 'pinia';
import { useCustomerStore } from '@/stores/customer/customer.store';
import { useGlobalStore } from '@/stores/global/global.store';
import { useDebtSolutionsStore } from '../store/debtsolutions.store';
import ContactRep from '@/components/ContactRep/ContactRep.vue';
import { mdiChevronDown, mdiChevronUp } from '@mdi/js';
import { OnexButton } from '@primerica/onex-ui-lib';
import type { IContactRepPayload } from '@/shared/api/models.bff.ts';

const componentOptions: ComponentOptions = {
  name: 'DebtSummary',
  data: () => ({
    valCurrentDebt: 0,
    valInDebtFor: 0,
    valTotIntPaid: 0,
    valTotalMonthlyPay: 0,
    debtDataArray: [],
    document: {
      title: '',
      content: '',
      type: '',
      loading: false,
    },
    contactYourRep: false,
    policy: {},
    selectedexpand: -1,
    index: 0,
    mdiChevronDown,
    mdiChevronUp,
  }),
  mixins: [openInNewWindow],
  components: {
    ContactRep,
    OnexButton,
  },
  methods: {
    ...mapActions(useCustomerStore, ['contactRepresentative']),
    sendRepEmail(emailPayload: IContactRepPayload) {
      this.contactRepresentative(emailPayload);
    },
    contact_your_rep_close() {
      this.contactYourRep = false;
    },
    callContactYourRep() {
      this.contactYourRep = true;
    },
    ViewMyPlan() {
      if (this.$route.path !== '/debtsolutions/myplan') {
        this.$emit('changeTab', 1);
      }
    },
    async openImportantDisc() {
      await this.openInNewWindow({
        url: `${window.appConfig.content_stack}/blt676ecb292039a611/MISC-006.pdf`,
        target: '_blank',
      });
    },
  },
  computed: {
    ...mapState(usePolicyStore, ['policiesSortedByDate']),
    ...mapState(useCustomerStore, ['investmentsSortedByDate', 'customerProfile']),
    ...mapState(useGlobalStore, ['getAgent', 'agents']),
    ...mapState(useDebtSolutionsStore, {
      debts: 'debts',
      unpaidDebts: 'unpaidDebts',
      paidOffDebts: 'paidOffDebts',
      planWOStacking: 'planWOStacking',
      planWStacking: 'planWStacking',
      twoOrMoreDebtsAndMinOneUnpaidDebt: 'twoOrMoreDebtsAndMinOneUnpaidDebt',
    }),
    sender() {
      try {
        return {
          email: this.customerProfile?.email || '',
          phone: this.customerProfile?.mobilePhone || '',
          firstName: this.customerProfile.firstName,
          lastName: this.customerProfile.lastName,
        };
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('\n🚀 ~ error:', error);
      }
    },
    hasReps() {
      try {
        return this.agents?.length > 0;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('\n🚀 ~ error:', error);
      }
    },
    getBalance() {
      try {
        const balance = this.planWOStacking?.planTotals?.balance;
        if (Number.isNaN(balance)) {
          return '';
        }
        return this.$n(balance, 'currency', 'en-US');
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('\n🚀 ~ error:', error);
      }
    },
    getWillBeInDebtFor() {
      try {
        if (this.planWOStacking.planTotals === undefined) {
          return '';
        }
        return `${this.planWOStacking?.planTotals?.debtPayoffYears} ${this.$t('L_yrs_dot_slash')} ${
          this.planWOStacking?.planTotals?.debtPayoffMonths
        } ${this.$t('L_mos_dot_slash')}`;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('\n🚀 ~ error:', error);
      }
    },
    getTotalInterestPaid() {
      try {
        const prjIntPaid = this.planWOStacking?.planTotals?.projectedInterestPaid;
        if (Number.isNaN(prjIntPaid)) {
          return '';
        }
        return this.$n(prjIntPaid, 'currency', 'en-US');
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('\n🚀 ~ error:', error);
      }
    },
    getMonthlyPayment() {
      try {
        const minPayment = this.planWOStacking?.planTotals?.minPayment;
        if (Number.isNaN(minPayment)) {
          return '';
        }
        return this.$n(minPayment, 'currency', 'en-US');
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('\n🚀 ~ error:', error);
      }
    },
    getTimeForFasterPaymentDate() {
      try {
        if (this.planWStacking === undefined) {
          return '';
        }
        let totalMonthsWStacking =
          (parseInt(this.planWStacking?.planTotals?.debtPayoffYears, 10) || 0) * 12;
        totalMonthsWStacking += parseInt(this.planWStacking?.planTotals?.debtPayoffMonths, 10) || 0;
        let totalMonthsWOStacking =
          (parseInt(this.planWOStacking?.planTotals?.debtPayoffYears, 10) || 0) * 12;
        totalMonthsWOStacking +=
          parseInt(this.planWOStacking?.planTotals?.debtPayoffMonths, 10) || 0;

        if (totalMonthsWStacking > 0 && totalMonthsWOStacking > 0) {
          const diffYears = Math.floor((totalMonthsWOStacking - totalMonthsWStacking) / 12);
          const diffMonths = (totalMonthsWOStacking - totalMonthsWStacking) % 12;
          return `${diffYears} ${this.$t('L_years_and')} ${diffMonths} ${this.$t('L_months')}`;
        }
        return '';
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('\n🚀 ~ error:', error);
      }
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};

export default defineComponent(componentOptions);
</script>
<style lang="scss" scoped>
.rightSideGrey {
  background-color: #eeeeee;
}
.rightSideGreyMob {
  background-color: #eeeeee;
  padding: 0 5px 0 5px;
}
.max-btn-width {
  max-width: 260px;
}
.biggerBlue {
  font-size: 24px;
  color: #063562;
  font-weight: bold;
  padding-bottom: 0;
}
.biggerBlueMob {
  font-size: 18px;
  color: #063562;
  font-weight: bold;
  padding-bottom: 5px;
}
.roundedBubble {
  border-radius: 16px;
  background-color: white;
  padding: 2px 2px 2px 2px;
  font-size: 28px;
  font-weight: 600;
  height: 50px;
  line-height: 50px;
  width: 252px;
  max-width: 252px;
  margin: auto;
}
.roundedBubbleMob {
  border-radius: 16px;
  background-color: white;
  padding: 0 10px 10px 10px;
  font-size: 18px;
  font-weight: 600;
  height: 32px;
  line-height: 32px;
  width: 180px;
  max-width: 180px;
  margin: auto;
}
.labelForRoundedBubble {
  font-weight: 400;
  padding: 20px 0 2px 0;
  font-size: 18px;
}
.labelForRoundedBubbleMob {
  font-weight: 400;
  padding: 20px 0 2px 0;
  font-size: 16px;
}
.widthViewMyPlanBtn {
  width: 220px;
}
.view_important_assumptions {
  color: #02579e;
  font-size: 16px;
  padding: 10px 10px 10px 10px;
}
.view_important_assumptionsMob {
  color: #02579e;
  font-size: 16px;
  padding: 2px 3px 10px 3px;
}
.get_out_of_debt {
  font-size: 18px;
  color: #333333;
  padding-top: 16px;
}
.get_out_of_debtMob {
  font-size: 18px;
  color: #333333;
  padding-top: 10px;
}
.if_you_have_questions_about_debt {
  font-size: 18px;
  color: #333333;
  font-weight: 600;
}
.Contact_Your_Representative {
  background-color: #002c56;
  font-size: 18px;
}
.moveleftByTen {
  margin-left: -10px;
}
.borderColorMarine {
  border: 1px solid #063562;
}
.backgroundWhite {
  background-color: white;
}
.noPaddingBottom {
  padding-bottom: 0 !important;
}
.grayBorderBottom {
  border-bottom: 1px solid #cccccc;
}
.disabledViewMyPlanBtn {
  background-color: #eeeeee !important;
  color: #adadad !important;
}
.enabledViewMyPlanBtn {
  background-color: #063562 !important;
  color: white !important;
}
.cursorPointer {
  cursor: pointer;
}
.currentDebtSummary {
  padding: 24px 0 24px 12px;
}
.currentDebtSummaryMob {
  text-align: center;
  padding: 12px 0 12px 12px;
}
.contactYourRepButtonText {
  font-size: 16px;
  @media only screen and (min-width: 800px) {
    font-size: 17px;
  }
}
</style>
